module.exports = __webpack_public_path__ + "img/icon-vehicle-type-n1.60a91bcc.svg";